function cov_2p7bvu58ae() {
  var path = "/app/src/components/pay-next-month-tab/index.ts";
  var hash = "7718b897520e7f647bb6a92c29e80f5e593dc717";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/pay-next-month-tab/index.ts",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "7718b897520e7f647bb6a92c29e80f5e593dc717"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2p7bvu58ae = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2p7bvu58ae();
export { PayNextMonthTab } from './pay-next-month-tab';